// src/Pages/GoogleDriveConnectionPage.js

import {useEffect} from "react";
import CONFIG from "../Services/CONFIG";
import {useLocation, useNavigate} from 'react-router-dom';
import {useAuth} from "../Contexts/AuthContext";
import {ConnectionApiProvider, useConnectionApi} from "../Services/ConnectionApiProvider";

function GoogleDriveConnectionContent({canEdit}) {
  const { status } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { googleDriveConnection } = useConnectionApi();

  useEffect(() => {
    const handleGoogleDriveConnection = async () => {
      const params = new URLSearchParams(location.search);
      const code = params.get("code");
      const error = params.get("error");

      const redirectUri = CONFIG.GOOGLE_DRIVE_REDIRECT_URI;
      const connectionId = localStorage.getItem("connectionId");

      const navigateWithAlert = (type, message) => {
        navigate(`/organizations/${status.organization_id}/connections/${connectionId}`, {
          state: { type, message }
        });
      };

      if (code) {
        try {
          await googleDriveConnection(code, redirectUri, connectionId);
          console.log("Google Drive connected successfully");
          navigateWithAlert("success", "Google Drive connected successfully");
        } catch (err) {
          console.error("Error exchanging code:", err);
          navigateWithAlert("fail", "Failed to connect Google Drive");
        }
      } else if (error) {
        console.log("Google authorization canceled or failed:", error);
        navigateWithAlert("fail", "Google authorization canceled");
      } else {
        console.log("No code or error received from Google");
        navigateWithAlert("fail", "No code or error received from Google");
      }
    };

    handleGoogleDriveConnection();
  }, [googleDriveConnection, location.search, navigate, status.organization_id]);

  return <div>Please wait...</div>;
}

function GoogleDriveConnectionPage({canEdit}) {
  return (
    <ConnectionApiProvider>
      <GoogleDriveConnectionContent canEdit={canEdit}/>
    </ConnectionApiProvider>
  );
}

export default GoogleDriveConnectionPage;
